import {fetchSubstitutes} from '@/api/api';
import {useAppStore} from '@/store/app.store';
import type {BaseProduct, Substitute} from 'dummen-shared';
import {defineStore} from 'pinia';
import {type Ref, ref} from 'vue';

export const useSubstituteStore = defineStore('substitute-store', () => {

	const substituteWeek: Ref<number | null> = ref(null);
	const substituteYear: Ref<number | null> = ref(null);
	const substitutes: Ref<Array<Substitute>> = ref([]);

	const getQueryParams = (patId: string) => {
		const formattedWeek = substituteWeek.value?.toString().padStart(2, '0');
		const queryParams = `?week=${substituteYear.value}${formattedWeek}`;

		return patId ? `${queryParams}&formId=${patId}` : queryParams;
	};

	const showSubstitutesModal = async (region: string, week: number, year: number, product: BaseProduct) => {
		substituteWeek.value = week;
		substituteYear.value = year;

		const substitutesData = await fetchSubstitutes(region, product.patcode, getQueryParams(product.form?.patId));

		substitutes.value = substitutesData ?? [];

		useAppStore().substituteModalActive = true;
	};

	return {
		substituteWeek,
		substituteYear,
		substitutes,
		showSubstitutesModal
	};
});
